import { atom } from 'recoil';
import { Voip } from '@/types/api/mypage/options';

/**
 * NURO 光 でんわオプション情報を保持する state。
 * 契約状態、申込可否、付加サービス状態をまとめて持ち、申込・変更・解約画面の基礎データにする。
 */
export const VoipOptionInfoState = atom<Voip>({
  key: 'VoipOptionInfoState',
  default: {
    available: false,
    use_status: '未申込',
    can_entry: false,
    voip_sub_state: '',
    has_campaign: false,
    option: {
      option_number_notice: '',
      option_number_display: '',
      option_number_request: '',
      option_catch_phone: '',
      option_voice_warp: '',
      option_stop_nuisance_call: '',
    },
  },
});

export default VoipOptionInfoState;
